export default "__VITE_ASSET__31582ed4__"